import React from 'react'

import cn from 'classnames'

import { SiteContext } from 'context/site-context'

import Header from 'components/sections/Header'
import DirectoryList from 'components/sections/DirectoryList'
import Footer from 'components/sections/Footer'

import './index.scss'

const Results = props => {
  const [ site ] = React.useContext(SiteContext)

  return <div className={cn('page-wrapper', {isLoadingSiteData: site.isLoadingSiteData})}>
    <Header className="mini" showHeader={true} animate={false} />
    <DirectoryList state={props.state} city={props.city} />
    <Footer />
  </div>
}

export default Results
